import React from "react";
import { VisuallyHidden } from "react-aria";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../Clickables";

import styles from "./BurgerButton.module.scss";

interface Props {
    active: boolean;
    onPress: () => void;
    controls: string;
    label: string;
    className?: string;
}

/**
 * Animated burger / X icon button. Renders three bars that transition
 * into an X shape when `active` is true.
 */
export const BurgerButton = ({
    active,
    onPress,
    controls,
    label,
    className,
}: Props) => (
    <Clickable
        className={concatClassNames([styles.button, className])}
        onPress={onPress}
        aria-expanded={active}
        aria-controls={controls}
    >
        <svg
            viewBox="0 0 24 24"
            className={concatClassNames([
                styles.icon,
                active ? styles.iconOpen : "",
            ])}
            aria-hidden="true"
        >
            <rect
                className={styles.topBar}
                x="4"
                y="7"
                width="16"
                height="1"
                rx="0.5"
                fill="currentColor"
            />
            <rect
                className={styles.middleBar}
                x="4"
                y="11.5"
                width="16"
                height="1"
                rx="0.5"
                fill="currentColor"
            />
            <rect
                className={styles.bottomBar}
                x="4"
                y="16"
                width="16"
                height="1"
                rx="0.5"
                fill="currentColor"
            />
        </svg>
        <VisuallyHidden>{label}</VisuallyHidden>
    </Clickable>
);
